import { Controller } from "@hotwired/stimulus"
import * as echarts from "echarts"

// Connects to data-controller="echart"
export default class extends Controller {
  static values = {
    options: Object,
    theme: { type: String, default: null },
    width: { type: String, default: "100%" },
    height: { type: String, default: "400px" }
  }

  connect() {
    this.initChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  }

  initChart() {
    // Set dimensions on the element
    this.element.style.width = this.widthValue
    this.element.style.height = this.heightValue

    // Initialize ECharts instance with optional theme
    this.chart = echarts.init(this.element, this.themeValue)

    // Set the chart options
    if (this.hasOptionsValue) {
      this.chart.setOption(this.optionsValue)
    }

    // Handle window resize
    this.resizeObserver = new ResizeObserver(() => {
      this.chart.resize()
    })
    this.resizeObserver.observe(this.element)
  }

  // Public method to update chart options
  updateOptions(newOptions, notMerge = false, lazyUpdate = false) {
    if (this.chart) {
      this.chart.setOption(newOptions, notMerge, lazyUpdate)
    }
  }

  // Handle options value changes
  optionsValueChanged() {
    if (this.chart && this.hasOptionsValue) {
      this.chart.setOption(this.optionsValue)
    }
  }

  // Cleanup resize observer on disconnect
  disconnected() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
  }
}
